import { ProductTag } from './product-tag';
import { Deserializable } from '../../protocols/deserializable';
import { Variant } from './variant';
import { memoize } from '../../../modules/shared/decorators/memoize';

export class ProductTagGroup implements Deserializable {
  public companyId: number;
  public id: string;
  public name: string;
  public isCurated: boolean;
  public tags: ProductTag[];
  public deletedAt: number;
  public dateCreated: number;
  public lastModified: number;

  onDeserialize(): void {
    this.tags = window?.injector?.Deserialize?.arrayOf(ProductTag, this.tags || []);
  }

  @memoize
  getRelevantTagsFor(
    enabledCuratedProductTagGroupIds: string[],
    enabledCuratedProductTagIds: string[],
    variants: Variant[]
  ): ProductTag[] {
    return this.tags
      ?.filter(tag => variants.some(variant => variant.tagIds?.includes(tag.id) || variant.posTagIds?.includes(tag.id)))
      ?.filter(tag => tag?.isVisibleTag(enabledCuratedProductTagGroupIds, enabledCuratedProductTagIds));
  }

  isUnassignedTagWrapper(): boolean {
    return !this.id;
  }

  smooshInTagsFrom(other: ProductTagGroup): void {
    if (!other) return;
    this.tags = [...(this.tags || []), ...(other.tags || [])];
    this.tags = this.tags?.uniqueByProperty('id');
  }
}
